import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-dark text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-white text-2xl font-bold mb-4">
              <img src="./assets/Images/Logo/logo.png" alt="City Pulse" className="w-[200px]" />
            </h3>
            <p className="text-gray-400 mb-4 max-w-md">
              Leading provider of Title and Settlement Services. We deliver
              excellence in title examination, tax research, and data management
              to support the mortgage industry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              {/* <li>
                <Link to="/careers" className="hover:text-white transition-colors">
                  Careers
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-gray-400">
              {/* Email */}
              <li className="flex items-center gap-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21.75 6.75v10.5A2.25 2.25 0 0119.5 19.5h-15A2.25 2.25 0 012.25 17.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15A2.25 2.25 0 002.25 6.75m19.5 0l-9.75 6.75L2.25 6.75"
                  />
                </svg>
                <a
                  href="mailto:info@citypulsellc.com"
                  className="hover:text-white transition-colors"
                >
                  info@citypulsellc.com
                </a>
              </li>

              {/* Phone */}
              <li className="flex items-center gap-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 4.5l4.5-.75 2.25 4.5-2.25 1.5a15.75 15.75 0 007.5 7.5l1.5-2.25 4.5 2.25-.75 4.5A2.25 2.25 0 0119.5 21.75C9.75 20.25 3.75 14.25 2.25 4.5z"
                  />
                </svg>
                <a
                  href="tel:+19162932536"
                  className="hover:text-white transition-colors"
                >
                  +1 916 293 2536
                </a>
              </li>

              {/* Address (not clickable) */}
              <li className="flex items-start gap-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-gray-400 mt-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 21s7.5-6.75 7.5-12a7.5 7.5 0 10-15 0c0 5.25 7.5 12 7.5 12z"
                  />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
                <span>
                  4654 Scenic Vista Dr <br />
                  Folsom, 95630 <br />
                  USA
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} City Pulse. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

